import translatedTime from './translatedTime';

const formatDuration = (duration, typePeriod) => {
  if (typePeriod.at(-1) !== 's' && duration > 1) {
    return `${duration} ${translatedTime[typePeriod]}s`;
  } return `${duration} ${translatedTime[typePeriod]}`;
};

const getAccommodationsInfos = async ({ id, ...params }) => {
  let accommodationInfo = {};

  try {
    const url = `${process.env.REACT_APP_DOMAIN_URL}/${process.env.REACT_APP_ACCOMMODATION_URL}/${id}?`;
    const result = await fetch(url + new URLSearchParams({ ...params }));
    const {
      name, duration, typePeriod, totalThisAccommodation:
      {
        value: totalValue,
        onlyAccommodation,
        onlyAccommodationWithoutSR,
        onlyEnrol,
        onlyEnrolWithoutSR,
      }, partner,
    } = await result.json();

    const timeExpend = formatDuration(duration, typePeriod);

    accommodationInfo = {
      name,
      onlyAccommodation,
      onlyAccommodationWithoutSR,
      onlyEnrol,
      onlyEnrolWithoutSR,
      duration,
      typePeriod,
      totalValue,
      timeExpend,
      partner,
    };
  } catch (e) {
    // console.error(e);
  }

  return accommodationInfo;
};

export default getAccommodationsInfos;
